module.exports = __webpack_public_path__ + "img/23.073ce62e.jpg";